module.exports = __webpack_public_path__ + "static/assets/41851407ad2e0c982425f2df0e0ff75a.png";